import ClienteService from "../services/cliente";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { routes as definedRoutes } from "constants/routes.constants";
import { AuthRoute } from "components/Routes/AuthRoute";
import { PublicRoute } from "components/Routes/PublicRoute";

// eslint-disable-next-line react/display-name
const pageRenderMiddleware = (RouteComponent) => (props) => {
  const localEntrega = ClienteService.localEntrega;

  if (localEntrega) {
    const { segmento, email } = localEntrega;

    if (segmento === "CONTASIM" && !email) {
      return <Redirect to="/personal-data" />;
    }
  }

  return <RouteComponent {...props} />;
};

const routes = definedRoutes.map((route) => {
  if (["/home", "/consumption", "/finances"].includes(route.path)) {
    return { ...route, middleware: pageRenderMiddleware };
  }
  return route;
});

export default function Routes() {
  return (
    <Router>
      <Switch>
        {routes.map(({ path, exact, redirect, component, isProtected }) => {
          if (redirect) {
            return (
              <Route key={path} exact={exact} path={path}>
                <Redirect to={redirect} />
              </Route>
            );
          }
          return isProtected ? (
            <AuthRoute
              key={path}
              path={path}
              component={component}
              exact={exact}
            />
          ) : (
            <PublicRoute
              key={path}
              path={path}
              component={component}
              exact={exact}
            />
          );
        })}
      </Switch>
    </Router>
  );
}
